export const CDN_BASE_URL = 'https://cdn1.home24.net';
